export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/recording-icon.svg?b1d6bd8fb121f44fcd3fce6b82fa2d6d";